export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/index.js
// module id = 12
// module chunks = 0